import { BaseService } from 'core/services';
import ImportReferenceTypeRouteService from './ImportReferenceTypeRouteService';

class ImportReferenceTypeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ImportReferenceTypeRouteService());
    }
}

export default ImportReferenceTypeService;
